import { useIsCompactViewport } from '@repo/studio-hooks-dom/use-breakpoint'
import { useDockResizeHandle } from '../../hooks/use-dock-resize-handle'
import { useFloatingPanelPosition } from '../../hooks/use-floating-panel-position'
import { useOpenShell } from '../../hooks/overlay/use-open-shell'
import { useScrimFade } from '../../hooks/overlay/use-scrim-fade'
import { closeAidaOverlay, useAidaOverlayStore } from '../../stores/overlay-store'
import { detachedPanelStyle } from '../../utils/overlay/detached-panel-style'
import { AidaDetachedPanel } from '../overlay/detached-panel'
import { AidaFullscreenDialog } from '../overlay/fullscreen-dialog'
import { useAidaOverlayPortal } from './aida-overlay-host'

export function AidaFullscreenShell() {
  const origin = useAidaOverlayStore(state => state.origin)
  const { setFullscreenSlot, portalContainerRef } = useAidaOverlayPortal()
  const { shellRef, showShell } = useOpenShell(origin, true)
  const fadeScrim = useScrimFade(true)

  return (
    <AidaFullscreenDialog
      open
      onClose={closeAidaOverlay}
      origin={origin}
      showShell={showShell}
      shellRef={shellRef}
      fadeScrim={fadeScrim}
      setFullscreenSlot={setFullscreenSlot}
      portalContainerRef={portalContainerRef}
    />
  )
}

export function AidaDockShell() {
  const { setDetachedSlot } = useAidaOverlayPortal()
  const isCompact = useIsCompactViewport()
  const dockWidth = useAidaOverlayStore(state => state.dockWidth)
  const dockResize = useDockResizeHandle(!isCompact)

  return (
    <AidaDetachedPanel
      shell="dock"
      setDetachedSlot={setDetachedSlot}
      floatingDrag={null}
      dockResize={isCompact ? null : dockResize}
      style={detachedPanelStyle('dock', { x: 0, y: 0 }, dockWidth, 0)}
      onEscape={closeAidaOverlay}
    />
  )
}

export function AidaFloatingShell() {
  const { setDetachedSlot } = useAidaOverlayPortal()
  const floatingDrag = useFloatingPanelPosition(true)

  return (
    <AidaDetachedPanel
      shell="floating"
      setDetachedSlot={setDetachedSlot}
      floatingDrag={floatingDrag}
      dockResize={null}
      style={detachedPanelStyle('floating', floatingDrag.position, 0, floatingDrag.height)}
      onEscape={closeAidaOverlay}
    />
  )
}
